var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"straight-title":_vm.additionalModuleName,"has-buttons":false,"disabled":true,"moduleEnabler":_vm.moduleEnabler}})
}
var staticRenderFns = []

export { render, staticRenderFns }